// extracted by mini-css-extract-plugin
export var chevron = "_id-3";
export var chevronRotated = "_id-4";
export var image = "_id-1";
export var imageContainer = "_id-0";
export var shippingAddress = "_id-2";